import React, { useState } from 'react'
import { Box } from '@mui/material'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import { FaberVouchersStats } from './Components/FaberVouchersStats'
import FaberVouchersTable from './Components/FaberVouchersTable'

export default function FaberVouchersMainDashboard() {
  /* TODO: FIND A MORE ELEGANT WAY TO DO THIS */
  const [numVouchers, setNumVouchers] = useState<number>()
  return (
    <PageLayoutV2 header='Vouchers - Faber'>
      <>
        <FaberVouchersStats setNumVouchers={setNumVouchers} />
        <ColorBox>
          <Box>
            <FaberVouchersTable numVouchers={numVouchers} />
          </Box>
        </ColorBox>
      </>
    </PageLayoutV2>
  )
}
